var React = require('react');

function PeopleMan1 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("title",{"key":1},"people-man-1"),React.createElement("circle",{"className":"a","cx":"12","cy":"6","r":"5.25","key":2}),React.createElement("path",{"className":"a","d":"M7.476,3.334A8.711,8.711,0,0,0,13.75,6,8.709,8.709,0,0,0,17.2,5.289","key":3}),React.createElement("path",{"className":"a","d":"M2.25,23.25a9.75,9.75,0,0,1,19.5,0","key":4}),React.createElement("path",{"className":"a","d":"M8.25,14.249V15a3.75,3.75,0,0,0,7.5,0v-.751","key":5})]);
}

PeopleMan1.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = PeopleMan1;

PeopleMan1.default = PeopleMan1;
